import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import { Pagination,empty } from 'element-ui'
import { Empty } from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
 
Vue.use(Pagination)
Vue.use(Empty )